import { CircularProgress as MuiCircularProgress } from '@mui/material';

import percentService from '../../services/percent';

/**
 * @deprecated
 * ### Description
 * `CircularProgress` has been deprecated and replaced by Classify `CircularLearningProgress`.
 *
 * ### Example
 * ```
 * import CircularLearningProgress from '@classify/react-product-components/CircularLearningProgress';
 * ```
 */
function CircularProgress({ value = null, maxValue = null, ...otherProps }) {
  let percent;
  let variant = 'indeterminate';

  if (value !== null && maxValue !== null) {
    percent = percentService.getPercent(value, maxValue);
    variant = 'determinate';
  }

  return <MuiCircularProgress variant={variant} value={percent} {...otherProps} />;
}

export default CircularProgress;
